import { InjectionToken } from '@angular/core';

import { DEFAULT_BRANDING } from './branding.defaults.js';
import type { BrandingConfig } from './branding.types.js';

/**
 * DI token holding the resolved `BrandingConfig`. Defaults to
 * `DEFAULT_BRANDING` so consumers don't have to call `provideEsTheme`
 * just to get the out-of-the-box EchoSpaces look.
 */
export const ES_BRANDING = new InjectionToken<BrandingConfig>('ES_BRANDING', {
  providedIn: 'root',
  factory: () => DEFAULT_BRANDING,
});
